import { useEffect, useState } from 'react';
import { Box } from "@chakra-ui/react"
import { Toaster, toaster } from "../../components/ui/toaster";
import InfiniteScroll from 'react-infinite-scroll-component';
import { useColorMode } from "../../components/ui/color-mode";
import { useWebHelper } from "@viabl/echo-web-client-core";
import TableControls2 from "../../components/table/tableControlsComponent";
import { Table, Spinner, TableCaption, Flex, Heading, Text, } from '@chakra-ui/react';
import TableControlsPermissions from "../../components/table/tableControlsPermissions";
import BundlesEditor from '../../components/echoRoleBundles/echoBundlesEditor';
import BundleAddRoles from '../../components/echoRoleBundles/echoBundleAddRole';
import BundleDelete from '../../components/echoRoleBundles/echoBundleDelete';

export interface Type {
    id: string,
    name: string,
}

export interface IBundle {
    id: string
    name: string
    parent_id: string
    parent_name: string
}

export interface ICreateAnnouncement {
    title: string,
    subtitle: string,
    body: string,
    tags: string[],
    isAcceptable: boolean,
}

export const EchoBundlesPage = () => {
    const [rows, setRows] = useState<IBundle[]>([]);
    const [statusFilter, setStatusFilter] = useState<string>("all")
    const [maxPages, setMaxPages] = useState<number>(0);
    const [rowsPerPage, setRowsPerPage] = useState<number>(10);
    const [page, setPage] = useState<number>(0);
    const [search, setSearch] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedType, setSelectedType] = useState<string>("803130a7-7a5c-43d3-b850-bf8ecba20cd9");
    const [nextPage, setNextPage] = useState<IBundle[]>([]);
    const [nextPageNo, setNextPageNo] = useState<number>(0);
    const { colorMode, toggleColorMode } = useColorMode();

    const [test, setTest] = useState()

    const webHelpers = useWebHelper();

    useEffect(() => {
        if (webHelpers.selectedEnvironment === null || webHelpers.selectedEnvironment === undefined) {
            console.log("environment is null?")
        }
    }, [])

    function goToNextPage(pageToLoad: number) { //used for infinite scrolling
        webHelpers.GetAsync("/api/rolebundles/search?page=" + pageToLoad + "&pageSize=" + rowsPerPage + "&query=" + search, "auth").then((data: any) => {
            if (data === undefined || data === null) {
                console.log(`No users found by the name "${search}", please try another search`, { 'variant': 'error' })
                setLoading(false);
            }
            else {
                setNextPage(data.results)
                data.results.forEach((element: IBundle) => {
                    setRows(rows => [...rows, element])
                })
                setMaxPages(data.max_pages)
                setLoading(false);
            }
        });
    }

    useEffect(() => {
        console.log(nextPageNo)
        setNextPageNo(0);
    }, [page]);

    function updateTable() {
        setLoading(true)
        setNextPageNo(page);
        webHelpers.GetAsync("/api/rolebundles/search?page=" + page + "&pageSize=" + rowsPerPage + "&query=" + search, "auth").then((data: any) => {
            if (data === undefined) {
                toaster.create({

                    title: `${data}: Unable to fetch bundles from the API`,
                    type: "error",

                });
            } else {
                setRows(data.results);
                setMaxPages(data.max_pages);
                setLoading(false);
            }
        }
        ).catch((error) => {
            setLoading(false);
            toaster.create({

                title: `${error.status}: Unable to fetch bundles from the API`,
                type: "error",

            });
        });
    }

    // Updating table in handle search change would cause it to lag behind the actual value
    useEffect(() => {
        updateTable();
    }, [
        page,
        rowsPerPage,
        search,
        statusFilter,
        webHelpers.selectedEnvironment
    ]);

    useEffect(() => {
        console.log(statusFilter)
        if (page !== 0) {
            setPage(0);
        }
    }, [statusFilter])

    const handleSearchChange = (event: any) => {
        const searchValue = event.target.value
        setSearch(searchValue);
        setPage(0);
    }

    const handleChangeRowsPerPage = (event: any) => {
        setLoading(true)
        setRowsPerPage(event.value[0]);
        setPage(0);
    };

    useEffect(() => {
        setRows([])
        if (page !== 0) {
            setPage(0);
        }
    }, [webHelpers.selectedEnvironment])

    const handleEnvChange = (event: any) => {
        setLoading(true);
        let isSuccess: boolean = webHelpers.SetEnvironmentById(event.value[0]);
        console.log(isSuccess);
    }

    return (
        <Flex direction={"column"}>
            <Toaster />
            <Heading marginTop={"20px"} color={colorMode === "light" ? "AbleBlue" : "AbleYellow"} as={"i"} justifySelf={"center"} display={"block"} fontWeight={"lighter"}>Echo Bundles</Heading>
            <Flex direction={"row"} justifyContent={"center"} marginTop={"10px"}>
                <div>
                    <Flex direction={"row"} justifyContent={"center"}>
                        <TableControlsPermissions handleChangeRowsPerPage={handleChangeRowsPerPage} search={search} handleSearchChange={handleSearchChange} rowsPerPage={rowsPerPage} />
                        <TableControls2 handleEnvChange={handleEnvChange} handleSearchChange={handleSearchChange} handleProfileChange={() => console.log("")} syncHandler={() => console.log("")} search={search} selectedType={selectedType}
                            userTypes={undefined} showTwilioSync={false} showUserTypes={false} handleLoadingChange={setLoading} handleRowsPerPageChange={handleChangeRowsPerPage} refresh={updateTable} page={page} maxPage={maxPages} setPage={setPage} rowsPerPage={rowsPerPage} />
                        <Box marginTop={2.5}>
                            <BundlesEditor existingBundle={null} intent='create' cb={updateTable}/>
                        </Box>
                    </Flex>
                    {/* need to have a section or method of showing already selected skills */}
                    {!loading ?
                        <>
                            {rows.length > 0 ?
                                // <ScaleFade initialScale={1} in={!loading}>
                                <Flex h={750 * ((rows.length / rowsPerPage) + 1) + 10 + "px"}>
                                    <>

                                        <Table.Root variant={"line"} textAlign="center">
                                            {rows.length === 0 ?
                                                <Text textAlign={"center"}>No Bundles Found!</Text>
                                                :
                                                <>

                                                    <InfiniteScroll
                                                        dataLength={rows.length}
                                                        next={() => {

                                                            if (nextPageNo < page) {
                                                                setNextPageNo(page + 1);
                                                                goToNextPage(page + 1)
                                                            }
                                                            else {
                                                                goToNextPage(nextPageNo + 1)
                                                                setNextPageNo(nextPageNo + 1);
                                                            }
                                                        }}
                                                        hasMore={nextPageNo <= maxPages - 2}
                                                        loader={
                                                            <Flex direction={"row"} justifyContent={"center"} width={"100%"} bgColor={colorMode === "light" ? "backgroundDarkGrey" : "backgroundGrey"} marginTop={{ base: "170px", lg: "100px" }}>
                                                                <Spinner color={colorMode === "light" ? "AbleBlue" : "AbleYellow"} marginTop={"10px"} marginBottom={"100px"} size={"xl"} display={(nextPageNo < maxPages) && nextPageNo !== 1 ? "flex" : "none"}></Spinner>
                                                                {/* <Image srcSet={loadingGif} alt="loading..." boxSize={'400px'} objectFit={"cover"} /> */}
                                                            </Flex>
                                                        }
                                                        endMessage={
                                                            <p style={{ textAlign: 'center' }}>
                                                                <b>{rows.length < rowsPerPage ? " " : "End of Results"}</b>
                                                            </p>
                                                        }
                                                        scrollThreshold={0.75}
                                                    >
                                                        <TableCaption>
                                                            <Text>
                                                                {rows.length < rowsPerPage ? " " : "Scroll Down to Load More Results"}
                                                            </Text>
                                                        </TableCaption>
                                                        <Table.Header>
                                                            <Table.Row>
                                                                <Table.ColumnHeader>Name</Table.ColumnHeader>
                                                                <Table.ColumnHeader>Parent Name</Table.ColumnHeader>
                                                                <Table.ColumnHeader></Table.ColumnHeader>
                                                                <Table.ColumnHeader></Table.ColumnHeader>
                                                                <Table.ColumnHeader></Table.ColumnHeader>
                                                            </Table.Row>
                                                        </Table.Header>
                                                        <Table.Body>
                                                            {rows.map((bundle: IBundle) =>
                                                                <Table.Row>
                                                                    <Table.Cell width={{base: 200, lg: 400}}>{bundle.name}</Table.Cell>
                                                                    <Table.Cell width={{base: 100, lg: 200}}>{bundle.parent_name ? bundle.parent_name : "none"}</Table.Cell>
                                                                    <Table.Cell pl={{base: 0, lg: 100}}><BundlesEditor existingBundle={bundle} cb={updateTable} intent='edit'/></Table.Cell>
                                                                    <Table.Cell pl={{base: 0, lg: 20}}><BundleAddRoles existingBundle={bundle} cb={updateTable}/></Table.Cell>
                                                                    <Table.Cell pl={{base: 0, lg: 20}}><BundleDelete cb={updateTable} existingBundle={bundle}/></Table.Cell>
                                                                </Table.Row>
                                                            )}
                                                        </Table.Body>
                                                    </InfiniteScroll>

                                                </>
                                            }
                                        </Table.Root>
                                    </>
                                </Flex>
                                // </ScaleFade>


                                :
                                <Flex justifyContent={"center"} marginTop={"100px"}>
                                    <Text>No Bundles Found!</Text>
                                </Flex>
                            }
                        </>
                        :
                        <Flex width={"100%"} justifyContent={"center"}>
                            <Spinner color={colorMode === 'light' ? "AbleBlue" : "AbleYellow"} size={"xl"} marginTop={"100px"} marginBottom={"100px"} />
                        </Flex>
                    }
                    {/* </ScaleFade> */}
                </div>
            </Flex>
        </Flex >
    )
}